<div class="quantity-control">
    <!-- Input is first to control stacking context -->
    <label class="display-label" [ngClass]="{ 'kk-visuallyhidden': !label }">
        {{ label ? label : ('forms.labels.quantity' | translateSafe) }}
    </label>
    <div class="content">
        <input
            class="input"
            [formControl]="formControl"
            [name]="control | controlToKeyName"
            placeholder="1"
            type="number"
            min="1"
            step="1"
        />
        <span class="decrease">
            <app-icon-button
                variant="secondary"
                [fullHeight]="true"
                [iconOnly]="true"
                iconName="remove"
                (click)="control.value > 1 && decrease()"
                >{{ 'general.action.decrease' | translateSafe }}</app-icon-button
            >
        </span>
        <span class="increase">
            <app-icon-button
                variant="secondary"
                [disabled]="control.value >= max"
                [fullHeight]="true"
                [iconOnly]="true"
                iconName="plus"
                (click)="control.value <= max && increase()"
                >{{ 'general.action.increase' | translateSafe }}</app-icon-button
            >
        </span>
    </div>
</div>
